export default function StatCard({ overline, value, sub, accent = false, testid }) {
  return (
    <div
      data-testid={testid}
      className={[
        "glass-card p-7 lg:p-8 transition-all hover:border-white/10",
        accent ? "relative overflow-hidden" : "",
      ].join(" ")}
    >
      {accent && (
        <div
          className="absolute inset-0 opacity-30 pointer-events-none"
          style={{
            background:
              "radial-gradient(circle at top right, rgba(212,175,55,0.18), transparent 60%)",
          }}
        />
      )}
      <div className="relative">
        <div className="overline">{overline}</div>
        <div className="mt-4 serif text-3xl lg:text-4xl text-[#EAEAEA] tracking-tight">{value}</div>
        {sub && <div className="mt-2 text-xs text-[#8A8A8A] mono">{sub}</div>}
      </div>
    </div>
  );
}
